var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditRounded = function SvgEditRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#fff",
    strokeWidth: 2,
    transform: "matrix(-1 0 0 1 40 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.707 11.293 4 4a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-.511.274l-5 1a1 1 0 0 1-1.177-1.177l1-5a1 1 0 0 1 .274-.511l11-11a1 1 0 0 1 1.414 0m-3.208 4.621-7.578 7.579-.647 3.232 3.233-.646 7.578-7.579zm2.5-2.5L22.915 14.5l2.585 2.585L26.585 16z"
  })));
};
export default SvgEditRounded;